import React from 'react';
import { QuoteData } from '../../types';
import { formatCurrency } from '../../lib/calculations';
import { UmlLogo } from '../UmlLogo';
interface ProposalHeaderProps {
  data: QuoteData;
}
export function ProposalHeader({
  data
}: ProposalHeaderProps) {
  return <div className="relative p-8 md:p-12 rounded-2xl flex flex-col md:flex-row items-center justify-between gap-8 overflow-hidden bg-charcoal-800 border border-white/10" data-id="element-128">
      {/* Subtle radial background tint */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,_var(--tw-gradient-stops))] from-gold/10 via-charcoal-800 to-charcoal-800 pointer-events-none" data-id="element-129"></div>

      {/* UML wordmark — top right */}
      <div className="absolute top-6 right-6 md:top-8 md:right-8 z-20 text-base md:text-lg" data-id="element-130">
        <UmlLogo variant="dark" data-id="element-131" />
      </div>

      <div className="flex-1 z-10" data-id="element-132">
        <div className="text-gold font-medium tracking-[0.2em] text-[10px] uppercase mb-6" data-id="element-133">
          {data.refinanceType.toUpperCase()} REFINANCE PROPOSAL
        </div>
        <h1 className="font-serif font-light text-5xl md:text-6xl mb-6 text-white" data-id="element-134">
          Hi {data.borrowerFirstName},
        </h1>
        <p className="text-gray-400 text-lg max-w-md leading-relaxed font-light" data-id="element-135">
          Here's the {data.refinanceType.toLowerCase()} we walked through.{' '}
          <strong className="text-white font-normal" data-id="element-136">
            {formatCurrency(data.cashToBorrower)} in your pocket
          </strong>{' '}
          at closing. The full breakdown is below.
        </p>
      </div>

      <div className="shrink-0 z-10 mt-8 md:mt-12" data-id="element-137">
        <div className="w-40 h-40 md:w-48 md:h-48 rounded-full overflow-hidden border-[1px] border-gold p-1" data-id="element-138">
          <div className="w-full h-full rounded-full overflow-hidden" data-id="element-139">
            <img src="https://images.unsplash.com/photo-1560250097-0b93528c311a?auto=format&fit=crop&q=80&w=400&h=400" alt={data.loName} className="w-full h-full object-cover grayscale opacity-90 hover:grayscale-0 transition-all duration-700" data-id="element-140" />
          </div>
        </div>
      </div>
    </div>;
}